import React from 'react';
import { Alert } from '@mui/material';

import { OpportunityCard } from 'containers/OpportunitiesPage/OpportunityCard/OpportunityCard';

import { Opportunity } from './types';

export const OpportunitiesList = ({
  opportunities,
  loading,
  setOpportunityPreview,
}: {
  opportunities: Opportunity[];
  loading: boolean;
  setOpportunityPreview: (opportunity: Opportunity) => void;
}) => (
  <>
    {!loading && opportunities.length === 0 ? (
      <Alert severity="info">
        No results found matching your search criteria. Please adjust your filters or search
        criteria and try again.
      </Alert>
    ) : null}
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gridTemplateRows: '1fr',
        gridColumnGap: '30px',
        gridRowGap: '30px',
      }}
    >
      {opportunities.map((opportunity) => (
        <OpportunityCard
          key={`${opportunity.provider}-${opportunity.providerId}`}
          opportunity={opportunity}
          setOpportunityPreview={setOpportunityPreview}
        />
      ))}
    </div>
  </>
);
